import styled, { css } from 'styled-components';

export const Header = styled.div`
  padding: 16px 24px 0 24px;
  position: relative;
`;

export const ListBar = styled.span`
  width: 6px;
  height: 24px;
  background-color: #222222;
  position: absolute;
  left: 0;
`;

export const RefundTag = styled.span`
  border-radius: 4px;
  padding: 4px 28px;
  ${props =>
    Array.isArray(props.bgColor) && props.bgColor.length === 1
      ? css`
          background: ${props.bgColor[0]};
        `
      : Array.isArray(props.bgColor) &&
        props.bgColor.length > 1 &&
        css`
          background-image: linear-gradient(90deg, ${props.bgColor.join(',')});
        `}
  color: ${props => props.fontColor || ''};
`;

export const TicketDetailWrap = styled.div`
  padding: 16px;
  border: 1px solid #e4e4e4;
  border-radius: 8px;
  margin-top: 10px;
  &:first-child {
    margin-top: 0;
  }
  ${props =>
    props.cnclPolicy &&
    css`
      padding: 12px 0 12px 0;
    `}
`;

export const TicketDetailBody = styled.div`
  padding: 20px 24px ${props => (props.bottomSpc ? '20px' : '0')};
`;

export const CnclPolicySubHd = styled.div`
  padding: 0 10px;
`;

export const CancellationWrap = styled.div`
  border-top: 2px solid #e1e7ee;
  padding: 15px 15px 0;
  margin-top: 15px;
`;

export const Csrow = styled.div`
  display: table-row;
`;

export const Cscell = styled.div`
  display: table-cell;
  padding: 8px 0;
  ${props =>
    props.bgColor
      ? props.bgColor.length > 1
        ? `background-image: linear-gradient(90deg, ${props.bgColor.join(',')});`
        : `background-color: ${props.bgColor[0]};`
      : ''}
  &:nth-child(2) {
    border-left: 1px solid #e4e4e4;
    text-align: right;
  }

  ${props =>
    props.hd &&
    css`
      border-bottom: 1px solid #e4e4e4;
      color: #717171;
      padding-top: 0;
    `}
  ${props =>
    props.today &&
    css`
      // color: #156128;
      position: relative;
      z-index: 1;
      &:before {
        content: '';
        position: absolute;
        top: 0;
        bottom: 0;
        right: -15px;
        ${props =>
          props.bgColor
            ? props.bgColor.length > 1
              ? `background-image: linear-gradient(90deg, ${props.bgColor.join(',')});`
              : `background-color: ${props.bgColor[0]};`
            : ''}
        z-index: -1;
        left: -15px;
        border-bottom-left-radius: 8px;
        border-bottom-right-radius: 8px;
      }
      &:first-child:before {
        right: 0;
      }
      &:last-child:before {
        left: 0;
      }
    `}
`;

export const Cstable = styled.div`
  display: table;
  border-collapse: collapse;
  width: 100%;
`;

export const CancellationBlock = styled.div`
  width: 45%;
`;

export const ArrowWrap = styled.span`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: #e5f3ff;
  display: flex;
  align-items: center;
  justify-content: center;
  .downArw {
    transform: rotate(180deg);
  }
`;

export const CancellationPenalityBlock = styled.div`
  width: 49%;
  padding: 15px 15px 0;
  background-color: #f4f4f4;
  border-radius: 8px;
`;
